<template>
  <div class="select-mcmp">
    <div @click="toggleDropdown" class="box">
      <span class="value">{{ selectedText }}</span>
      <v-icon
        v-if="!expanded"
        :class="'icon select-icon'"
        icon
        >fa-angle-down</v-icon
      >
      <v-icon
        v-else
        :class="'icon select-icon'"
        icon
        >fa-angle-up</v-icon
      >
    </div>
    <ul :class="'options ' + (expanded ? 'expanded' : '')">
      <li
        v-if="allOption"
        @click="updateValue"
        class="option"
        :data-value="allOpt"
      >
        {{ $t("all") }}
      </li>
      <li
        class="option"
        @click="updateValue"
        v-for="(option, index) in options"
        :key="index"
        :data-value="option.value ? option.value : option"
      >
        {{ option.text ? option.text : option }}
      </li>
    </ul>
  </div>
</template>

<script>
import { SELECT_SINGLE } from "./constants";

export default {
  name: "SwisetSelect",
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    allOption: {
      type: Boolean,
      required: false,
    },
    placeholder: {
      type: String,
    },
    changeEvent: {
      type: Function,
    },
  },
  data() {
    return {
      selectedValue: undefined,
      selectedText: this.placeholder,
      expanded: false,
      allOpt: this.$i18n.messages[this.$i18n.locale].all,
    };
  },
  computed: {
    isSelected(e) {
      if (e.target) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    // Add click event listener to document to handle outside clicks
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateValue(e) {
      switch (this.type) {
        case SELECT_SINGLE:
          var valu = e.target.getAttribute("data-value");
          if(valu.includes(this.$t("all"))) {
            this.selectedValue = undefined;
            this.selectedText = this.placeholder;
            break;
          }
          this.selectedValue =
            e.target.textContent !== this.allOpt
              ? valu
              : undefined;
          this.selectedText = this.selectedValue
            ? e.target.textContent
            : this.allOpt;
          break;
        default:
          var val = e.target.getAttribute("data-value");
          if (!this.selectedValue) {
            this.selectedValue = [];
            e.target.parentNode
              .querySelectorAll(".option")
              .forEach((el, index) => {
                if (index > 1) el.classList.remove("selected");
              });
          }

          if (val !== this.allOpt) {
            e.target.classList.add("selected");
            if (!this.selectedValue.includes(val)) {
              this.selectedValue.push(val);
              this.selectedText = this.selectedValue.toString();
              if (this.selectedValue.length > 3) {
                this.selectedText = `${this.selectedValue[0]} +${
                  this.selectedValue.length - 1
                }`;
              }
            } else {
              e.target.classList.remove("selected");
              this.selectedValue.splice(this.selectedValue.indexOf(val), 1);
              this.selectedText = this.selectedValue.toString();
              if (this.selectedValue.length > 3) {
                this.selectedText = `${this.selectedValue[0]}, +${
                  this.selectedValue.length - 1
                }`;
              }
              if (!this.selectedValue.length) {
                e.target.parentNode
                  .querySelectorAll(".option")
                  .forEach((el, index) => {
                    if (index > 1) el.classList.add("selected");
                  });
              }
            }
          } else {
            this.selectedValue = [];
            e.target.parentNode
              .querySelectorAll(".option")
              .forEach((el, index) => {
                if (index > 1) el.classList.add("selected");
              });
          }
          if (this.selectedValue.length == 0) {
            this.selectedValue = undefined;
            this.selectedText = this.placeholder;
          }
          break;
      }
      if (this.type == SELECT_SINGLE) this.toggleDropdown();
      this.$emit("input", this.selectedValue);
      if (this.changeEvent) this.changeEvent();
      // Add filled class when value is selected
      if (this.selectedValue) {
        this.$el.querySelector('.box').classList.add('filled');
      } else {
        this.$el.querySelector('.box').classList.remove('filled');
      }
    },
    handleClickOutside(event) {
      // If click is outside this select, collapse it
      if (!this.$el.contains(event.target)) {
        this.expanded = false;
      }
    },
    toggleDropdown() {
      // First collapse any other expanded selects
      const allSelects = document.querySelectorAll('.select-mcmp');
      allSelects.forEach(select => {
        if (select !== this.$el) {
          const selectComponent = this.$root.$children.find(child => 
            child.$el === select
          );
          if (selectComponent) {
            selectComponent.expanded = false;
          }
        }
      });

      // Then toggle this select
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss">
@import "src/global";

.select-mcmp {
  position: relative;

  .box {
    position: relative;
    padding: 5px 14px;
    padding-right: 46px;
    background-color: transparent;
    font-family: "Avenir", sans-serif;
    border-radius: 4px;
    border: 1px solid var(--v-mediumGray-base);
    transition: all 0.3s ease;

    // Default/Placeholder state - ensure both text and icon use the same color
    .value, .icon {
      color: var(--v-mediumGray-base) !important;
      transition: color 0.3s ease;
    }

    .value {
      display: block;
      font-style: normal;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 20px;
    }

    .icon {
      position: absolute;
      right: 3px;
      top: 15px;
      margin: 0 16px;
      font-size: 18px;
    }

    // Hover state
    &:hover {
      cursor: pointer;
      border: 1px solid var(--v-mainBlack-base);

      .value, .icon {
        color: var(--v-black-base) !important;
      }
    }

    // Filled/Selected state
    &.filled {
      background-color: transparent;
      border: 1px solid var(--v-mainGreen-base);

      .value, .icon {
        color: var(--v-black-base) !important;
      }
    }

    // Disabled state
    &.disabled {
      background-color: #EEEEEE;
      cursor: not-allowed;

      .value, .icon {
        color: #9A9A9A !important;
      }

      &:hover {
        box-shadow: none;
      }
    }
  }

  .options {
    display: none;
    width: 100%;
    max-height: 0;
    position: absolute;
    background-color: var(--v-mainWhite-base);
    overflow: auto;
    list-style-type: none;
    transition: max-height 0.15s ease-out;
    padding: 0;
    margin-top: 5px;
    z-index: 5;
    padding-bottom: 10px;

    .option {
      line-height: 1.2;
      position: relative;
      padding: 10px 14px;
      background-color: transparent;
      color: var(--v-black-base);
      font-family: "Avenir", sans-serif;
      border-bottom: 0.5px solid var(--v-mediumGrey-base);
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        background-color: darken(#EEEEEE, 5%);
        color: var(--v-black-base);
        cursor: pointer;
      }

      &.first-option {
        font-size: 12px;
        padding: 5px 14px;
        font-style: normal;
        border: 0;
        color: #9A9A9A;

        &:hover {
          cursor: default;
          background-color: #EEEEEE;
        }
      }

      &.selected {
        color: var(--v-darkGreen-base) !important;
        background-color: var(--v-mainGreen-base);
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &.expanded {
      display: block;
      max-height: 500px;
      transition: max-height 0.25s ease-in;
    }
  }
}
</style>
